import { render, staticRenderFns } from "./organization-survey-members-form.vue?vue&type=template&id=56b6cb47"
import script from "./organization-survey-members-form.vue?vue&type=script&lang=js"
export * from "./organization-survey-members-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports